module.exports = __webpack_public_path__ + "static/media/bar4.c07c821c.svg";